import {
  IIdentifyBreedIdData,
  IRequestOptions,
  IResponseResult,
} from 'models/api.model'
import { breedIdApiKey, breedIdFetchUrl, RequestMethod } from 'root-constants'
import { ApiService } from 'services/api.service'

export class BreedIdApi {
  private api: ApiService

  constructor(api: ApiService) {
    this.api = api
  }

  async identifyBreed(
    file: File,
    signal?: AbortSignal,
  ): Promise<IResponseResult<IIdentifyBreedIdData>> {
    const formData = new FormData()
    formData.append('dogImage', file)

    const url =
      breedIdFetchUrl[import.meta.env.CURRENT_ENV] || breedIdFetchUrl.dev

    const options: IRequestOptions = {
      method: RequestMethod.POST,
      body: formData,
      headers: new Headers({
        'x-api-key':
          breedIdApiKey[import.meta.env.CURRENT_ENV] || breedIdApiKey.dev,
      }),
      signal,
    }

    return this.api.makeCustomRequest<IIdentifyBreedIdData>(url, options)
  }
}
